// localStorage throws (SecurityError) when site data is blocked, in some
// private-browsing modes, and when the quota is full. With no error boundary
// around the app, an uncaught throw during mount blanks the whole page, so
// every access goes through these.

export function lsGet(key) {
  try { return localStorage.getItem(key); } catch { return null; }
}

export function lsSet(key, value) {
  try { localStorage.setItem(key, value); } catch {}
}

export function lsRemove(key) {
  try { localStorage.removeItem(key); } catch {}
}

// Parsed JSON, or `fallback` if the key is missing, unreadable or corrupt.
export function lsGetJSON(key, fallback) {
  const raw = lsGet(key);
  if (raw == null) return fallback;
  try { return JSON.parse(raw); } catch { return fallback; }
}
